import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';
import Navbar from '../components/Navbar';
import { ToastContainer } from '../components/Toast';
import { useToast } from '../hooks/useToast';
import '../styles/Regalos.css';
import '../styles/Extras.css';

// Test de compatibilidad sanjuanino: con 5 respuestas o más se ve el % de afinidad en Explorar
export default function AfinidadPage() {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const { toasts, success, error } = useToast();
  const [preguntas, setPreguntas] = useState(null);
  const [resp, setResp] = useState({});
  const [minimo, setMinimo] = useState(5);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    api.compatTest()
      .then(d => { setPreguntas(d.preguntas); setResp(d.respuestas || {}); setMinimo(d.minimo || 5); })
      .catch(e => { setPreguntas([]); error(e.message || 'No se pudo cargar el test.'); });
  }, [error]);

  const cant = Object.keys(resp).length;

  const guardar = async () => {
    setGuardando(true);
    try {
      const d = await api.guardarCompat(resp);
      refreshUser();
      if (d.completas) { success('💞 ¡Listo! Ya ves tu % de afinidad en Explorar.'); setTimeout(() => navigate('/explorar'), 900); }
      else success(`Guardado. Te faltan ${minimo - Object.keys(d.respuestas).length} para ver la afinidad.`);
    } catch (e) { error(e.message || 'No se pudo guardar.'); }
    finally { setGuardando(false); }
  };

  const compartir = async () => {
    const url = window.location.origin;
    const texto = '¿Zonda o tormenta? ¿Asado o empanadas? Hacé el test de afinidad sanjuanino en Cupido con Mate 🧉💞';
    try {
      if (navigator.share) await navigator.share({ title: 'Test de afinidad sanjuanino', text: texto, url });
      else { await navigator.clipboard.writeText(`${texto} ${url}`); success('Enlace copiado. ¡Pasáselo a tus amigos!'); }
    } catch { /* cancelado */ }
  };

  return (
    <div className="regalos-page">
      <Navbar />
      <ToastContainer toasts={toasts} />
      <div className="regalos-container container">
        <h1 className="regalos-title" style={{ marginBottom: 8 }}>💞 Test de afinidad sanjuanino</h1>
        <p className="regalos-sub" style={{ marginBottom: 24 }}>
          Respondé al menos {minimo} preguntas y vas a ver qué tan compatibles son con cada perfil. Llevás {cant} de {preguntas?.length || 0}.
        </p>

        {!preguntas ? <p className="regalos-empty">Cargando…</p> : (
          <div className="afinidad-lista">
            {preguntas.map(p => (
              <div key={p.id} className="afinidad-pregunta">
                <div className="afinidad-texto">{p.texto}</div>
                <div className="afinidad-opciones">
                  {p.opciones.map((o, i) => (
                    <button key={o} type="button"
                      className={`afinidad-opcion ${resp[p.id] === i ? 'activa' : ''}`}
                      onClick={() => setResp(r => ({ ...r, [p.id]: i }))}>{o}</button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="afinidad-pie">
          <button className="btn btn-primary btn-lg" onClick={guardar} disabled={guardando || cant === 0}>
            {guardando ? 'Guardando…' : 'Guardar respuestas'}
          </button>
          <button className="btn btn-outline btn-lg" onClick={compartir}>📤 Compartir el test</button>
        </div>
      </div>
    </div>
  );
}
